export default __webpack_public_path__ + "static/media/lethargy3.75e8447d.png";